<span #trigger cdkOverlayOrigin (click)="toggleDropdown()" class="w-4 block text-center">
  <fa-icon [icon]="icon"></fa-icon>
</span>
<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayOpen]="dropdownOpen"
  [cdkConnectedOverlayHasBackdrop]="false"
  [cdkConnectedOverlayPositions]="[
    { originX: 'end', originY: 'bottom', overlayX: 'end', overlayY: 'top' },
    { originX: 'end', originY: 'top', overlayX: 'end', overlayY: 'bottom' }
  ]"
  (backdropClick)="dropdownOpen = false"
  (detach)="dropdownOpen = false"
>
  <div class="dropdown-wrapper">
    <div class="dropdown-body rounded">
      <input
        *ngIf="!hideSearch"
        type="text"
        class="search-input"
        placeholder="Search..."
        [formControl]="searchControl"
      />
      <div
        class="option"
        *ngFor="let option of filteredOptions"
        (click)="selectOption(option)"
      >
        {{ option.text }}
      </div>
    </div>
  </div>
</ng-template>
